// @flow

import { useCallback } from 'react'
import { equals, or, pathOr, prop, propOr } from 'ramda'
import { isNotNilOrEmpty } from 'ramda-adjunct'

import { BUTTON_KEY_CODES } from '@alphaott/smart-tv-platforms'

const initialHeight = window.innerHeight

export const useHorizontalArrows = ({ switchFocusKeys = {}, ref, setFocus, onKeyDown }) => {
  const isHorizontalArrow = useCallback(({ keyCode }) => {
    const isLeft = equals(BUTTON_KEY_CODES.ARROW_LEFT, keyCode)
    const isRight = equals(BUTTON_KEY_CODES.ARROW_RIGHT, keyCode)

    return or(isLeft, isRight)
  }, [])

  const handlePressHorizontalArrow = useCallback(
    // eslint-disable-next-line complexity
    (keys, { keyCode }) => {
      const keyboardVisible = window.innerHeight < initialHeight

      const currentInputRef = prop('current', ref)
      const valueLength = pathOr(0, ['value', 'length'], currentInputRef)
      const cursorPosition = propOr(0, 'selectionStart', currentInputRef)
      const isRightArrow = equals(BUTTON_KEY_CODES.ARROW_RIGHT, keyCode)
      const isLeftArrow = equals(BUTTON_KEY_CODES.ARROW_LEFT, keyCode)
      const isLastPosition = equals(cursorPosition, valueLength)
      const isFirstPosition = equals(cursorPosition, 0)

      if (isLeftArrow && isFirstPosition && keys?.left && !keyboardVisible) {
        setFocus && setFocus(keys?.left)
      }

      if (isRightArrow && isLastPosition && keys?.right && !keyboardVisible) {
        setFocus && setFocus(keys?.right)
      }
    },
    [ref, setFocus],
  )

  const handleOnKeyDown = useCallback(
    // eslint-disable-next-line complexity
    (event) => {
      if (isHorizontalArrow(event)) {
        if (isNotNilOrEmpty(switchFocusKeys)) {
          handlePressHorizontalArrow(switchFocusKeys, event)
        }

        event.stopPropagation()
      }

      onKeyDown && onKeyDown(event)
    },
    [handlePressHorizontalArrow, switchFocusKeys, isHorizontalArrow, onKeyDown],
  )

  return handleOnKeyDown
}

export default useHorizontalArrows
